import React, { useContext, useMemo, useState, Fragment, useEffect } from 'react';
import { Collapse, Table, Tooltip } from 'antd';
import BmTotvsAditivo from './AditivoTotvs'
import BmTotvs from './BmTotvs'
import { getAllAditivoTotvsByContatoId, AditivoTotvs } from '@app/api/aditivoTotvs';
interface AbaBmTotvsProps {
    contratoId: any;
    isMultiplosGestores: boolean;
}

const AbaBmTotvs = (props: AbaBmTotvsProps) => {
    const { contratoId, isMultiplosGestores } = props
    const { Panel } = Collapse;
    const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
    const [mostrarAditivoContrato, setMostrarAditivoContrato] = useState<boolean>(false);
    const atualizarInformacoestela = () => {
        setAtualizarTela(!atualizarTela);
    }

    const getAllAditivoTotvs = useMemo(() => {
        if (contratoId) {
            return getAllAditivoTotvsByContatoId(contratoId).then((data) => {
                if (data) {
                    const aditivoTotvs = data as AditivoTotvs[];
                    if (aditivoTotvs.length === 0) {
                        setMostrarAditivoContrato(true);
                    }
                }
            });
        }
    }, [contratoId]);

    return (
        <>
            {contratoId && mostrarAditivoContrato === false ? (<BmTotvsAditivo contratoSelecinado={contratoId} atualizarTela={atualizarInformacoestela} isMultiplosGestores={isMultiplosGestores} ></BmTotvsAditivo>) : (<> </>)}

            {contratoId && mostrarAditivoContrato === true ? (<BmTotvs contratoSelecinado={contratoId} atualizarTela={atualizarInformacoestela} isMultiplosGestores={isMultiplosGestores} ></BmTotvs>) : (<>  </>)}
        </>
    );
};
export default AbaBmTotvs;


